const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || "http://localhost:8000"

// Default profile picture - a simple gray circle SVG as data URL
export const DEFAULT_PROFILE_PICTURE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Ccircle cx='100' cy='100' r='100' fill='%23e0e0e0'/%3E%3Cpath d='M100 90c-16.5 0-30-13.5-30-30s13.5-30 30-30 30 13.5 30 30-13.5 30-30 30zm0 20c-33 0-60 20-60 45v15h120v-15c0-25-27-45-60-45z' fill='%23bdbdbd'/%3E%3C/svg%3E"


